<script>
import { Line, mixins } from 'vue-chartjs'

export default Line.extend({
  props: ['chartData', 'height'],
  mixins: [ mixins.reactiveProp ],
  mounted () {
    this.renderChart(this.chartData, {
      maintainAspectRatio: false,
      legend: { display: false },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      scales: {
        xAxes: [{
          ticks: { autoSkip: true, maxTicksLimit: 8 },
          gridLines: { drawOnChartArea: false }
        }],
        yAxes: [{
          ticks: { beginAtZero: true, maxTicksLimit: 6 },
          gridLines: { display: true }
        }]
      },
      elements: {
        line: { tension: 0 },
        point: { radius: 2, hitRadius: 8, hoverRadius: 4, hoverBorderWidth: 2 }
      }
    })
  }
})
</script>



// WEBPACK FOOTER //
// StockHistoryChart.vue?10fed170